// extracted by mini-css-extract-plugin
export var animationContainer = "_cs-0";
export var asteriskIcon = "_cs-8";
export var conversationLeftSection = "_cs-4";
export var conversationListItem = "_cs-3";
export var conversationMiddleSection = "_cs-5";
export var conversationRightSection = "_cs-6";
export var detailsContent = "_cs-1";
export var listContainer = "_cs-7";
export var modalContent = "_cs-2";